// src/app/services/pages-content.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface PageContent {
  id: number;
  component_name: string;
  content: string;
  updated_at: string;
}

@Injectable({
  providedIn: 'root'
})
export class PagesContentService {
  // Adjust the API URL as needed for your PHP backend
  //private apiUrl = 'http://yourapi.com/pages_content_api.php';

  private apiUrl = location.hostname === 'localhost'
    ? 'http://localhost:8000/pages_content_api.php'
    : 'https://PHP-APIV10.allmyhugs.com/pages_content_api.php';

  constructor(private http: HttpClient) { }

  // Retrieve content for a specific component
  getContent(component: string): Observable<{ success: boolean; data: PageContent }> {
    return this.http.get<{ success: boolean; data: PageContent }>(
      `${this.apiUrl}?action=getContent&component=${component}`
    );
  }

  // Save updated content for a specific component
  saveContent(component: string, content: string): Observable<{ success: boolean; message: string }> {
    const payload = { component, content };
    return this.http.post<{ success: boolean; message: string }>(
      `${this.apiUrl}?action=saveContent`,
      payload
    );
  }
}
